import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, makeStyles } from '@material-ui/core/styles';
// import Button from '../../../components/Button.js';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { prettyDate } from '../../../lib/time.js';
import { ReviewAPI } from '../../../api';
import Loader from '../../../components/Loader.js';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Chip from '@material-ui/core/Chip';

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    cursor: 'pointer',
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    '&:hover': {
      backgroundColor: theme.palette.common.highlightBlue,
    },
  },
}))(TableRow);

const useStyles = makeStyles({
  root: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    alignContent: 'flex-start',
    justifyContent: 'flex-start',
    padding: '0',
  },
  title: {
    marginBottom: '1rem',
  },
  controls: {
    padding: '1rem 0',
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginLeft: '1rem',
  },
});

const ReviewsSummary = ({providerUuid, selectReview}) => {
  const classes = useStyles();
  const [excludeResponded, setExcludeResponded] = React.useState(true);
  const [data, setData] = React.useState(null);

  const toggleShowResponded = () => {
    setExcludeResponded(!excludeResponded);
  };

  const getData = async () => {
    try {
      const providerReviews = await ReviewAPI.getProviderReviews(providerUuid, true, excludeResponded, true);
      setData(providerReviews.payload);
    } catch (err) {
      console.error(err); // eslint-disable-line no-console
    }
  };

  const selectChipColor = (value) => {
    if (value === 'Yes') {
      return 'lightGreen';
    } else {
      return 'orange';
    }
  };

  React.useEffect(() => {
    getData();
  }, [excludeResponded]);  // eslint-disable-line

  if (data === null) {
    return (<Loader />);
  }

  return (
    <div className={classes.root}>
      <div className={classes.controls}>
        <FormControlLabel
          control={
            <Checkbox
              checked={excludeResponded}
              onChange={toggleShowResponded}
            />
          }
          label="Show reviews without responses only"
        />
      </div>
      <TableContainer>
        <Table className={classes.table} aria-label="Reviews table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Created</StyledTableCell>
              <StyledTableCell>Author</StyledTableCell>
              <StyledTableCell>Rating</StyledTableCell>
              <StyledTableCell>Reviewed Item</StyledTableCell>
              <StyledTableCell>Responded</StyledTableCell>
              <StyledTableCell>Content</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map(row => {
              const responded = (row.comments.length > 0) ? 'Yes' : 'No';
              const itemType = (row.item_type === 'provider') ? 'Provider Profile' : `Service Listing: ${row.item_uuid}`;
              return (
                <StyledTableRow
                  key={row.uuid}
                  onClick={() => selectReview(row.uuid)}
                >
                  <StyledTableCell>{prettyDate(row.created_at)}</StyledTableCell>
                  <StyledTableCell>{row.author_username}</StyledTableCell>
                  <StyledTableCell>{row.rating}</StyledTableCell>
                  <StyledTableCell>{itemType}</StyledTableCell>
                  <StyledTableCell><Chip label={responded} style={{backgroundColor:selectChipColor(responded)}} /></StyledTableCell>
                  <StyledTableCell>{row.content}</StyledTableCell>
                </StyledTableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

ReviewsSummary.propTypes = {
  providerUuid: PropTypes.string.isRequired,
  selectReview: PropTypes.func.isRequired,
};

export default ReviewsSummary;
